module.exports = __webpack_public_path__ + "img/badge_gray_she-holistic.02952f58.svg";